var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightcurve(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 112,
    viewBox: "0 0 1440 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1444.8 0.396484C657.98 173.128 389.015 97.1635 1.07068 38.0909C1.07068 38.0909 -14.4069 39.2501 1.06955 43.0665C424.857 109.618 583.662 147.852 1222.18 59.133C1400.49 34.3581 1444.8 18.4077 1444.8 18.4077V0.396484Z",
    fill: "url(#paint0_radial_870_6071)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_870_6071",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(780.955 111.046) rotate(16.6694) scale(1521.65 109.623)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF00E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A004D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightcurve);
export default __webpack_public_path__ + "static/media/Light curve.c31a1da633e90c387f72c4f6def81718.svg";
export { ForwardRef as ReactComponent };